// extracted by mini-css-extract-plugin
export default {"dashboardPage":"Dashboard_dashboardPage__FJjX9","content":"Dashboard_content__SqrZZ"};